<div>
  <mat-toolbar>
    <mat-toolbar-row>
      @if(!data){
      <button mat-icon-button (click)="onBackToResumen()"
        matTooltip="Ver informaci&oacute;n"><mat-icon>arrow_back</mat-icon></button>
      }@else if(!firmarAnexo){
      <button mat-dialog-close mat-button>Cerrar</button>
      }
      @if(firmas.length>0 && this.firmar===1){
      @if(!hasAnotations){
      &nbsp;
      <button mat-button (click)="addStamp()" [disabled]="!loadPdf || hasAnotations "
        matTooltip="Agregar firma electr&oacute;nica"><mat-icon>approval</mat-icon>Agregar firma</button>
      }
      @if(hasAnotations){
      &nbsp;
      <button mat-button (click)="removeStamp()" [disabled]="!hasAnotations"
        matTooltip="Quitar firma electr&oacute;nica"><mat-icon>approval</mat-icon>Quitar firma</button>
      }
      &nbsp;
      <button mat-flat-button (click)="signPdf()" color="primary" [disabled]="!(firmas.length>0 && hasAnotations)">
        {{firmarAnexo?"Firmar Anexo":"Firmar y enviar"}}
      </button>
      }
      <span class="sgd-spacer"></span>

      <button mat-icon-button id="zoomOut" (click)="zoomOut()"><mat-icon>remove</mat-icon></button>
      <button mat-icon-button id="zoomIn" (click)="zoomIn()"><mat-icon>add</mat-icon></button>
      <!--<span class="tool-divider" ></span>-->
      <button mat-icon-button id="previous"><mat-icon>arrow_back</mat-icon></button>
      <mat-form-field id="txtPage">
        <input matInput type="number" id="pageNumber">
      </mat-form-field>
      <button mat-icon-button id="next"><mat-icon>arrow_forward</mat-icon></button>
      &nbsp;
      <span style="display: none;">
        <pdf-zoom-toolbar></pdf-zoom-toolbar>
      </span>
    </mat-toolbar-row>
  </mat-toolbar>
</div>
<mat-dialog-content>
  <ngx-extended-pdf-viewer [src]="filePdf" [height]="'auto'" pageViewMode="single" spread="off" [(zoom)]="zoomSetting"
    [zoomLevels]="zoomLevels" [showUnverifiedSignatures]="true" [showBorders]="false" [(page)]="page"
    [sidebarVisible]="false" [textLayer]="true" [showToolbar]="false" [ignoreKeyboard]="true" [showDrawEditor]="false" [showStampEditor]="false"
    (pagesLoaded)="onPagesLoaded()"></ngx-extended-pdf-viewer>
</mat-dialog-content>